export default __webpack_public_path__ + "08bfef2975d3aab375cf63d7856dab1c.png";